import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=b997f876&scoped=true&"
import script from "./DetailForm.vue?vue&type=script&lang=ts&"
export * from "./DetailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b997f876",
  null
  
)

export default component.exports